<template>
  <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="md:flex md:items-center md:justify-between">
        <div class="flex min-w-0">
          <svg-vue class="content-title-icon" icon="font-awesome.home-solid"></svg-vue>
          <h1 class="content-title">
            {{ $t('Welcome') }}
          </h1>
        </div>
      </div>
    </div>
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="my-3">
        <ul class="grid grid-cols-2 gap-3 md:grid-cols-3 xl:grid-cols-4">
          <router-link
            v-show="visibility('pos_sales')"
            class="col-span-1 flex flex-col text-center cursor-pointer border-t-2 border-green-600 bg-white shadow rounded-md"
            tag="li"
            to="/pos"
          >
            <div class="flex-1 flex flex-col p-5">
              <div class="flex-shrink-0 mx-auto">
                <svg-vue class="block-link-icon" icon="font-awesome.life-ring-solid"></svg-vue>
              </div>
              <h3 class="form-description-head">
                {{ $t('Point of sale') }}
              </h3>
              <p class="form-description-text">
                {{ $t('Sale items and accessories') }}
              </p>
            </div>
          </router-link>
          <router-link
            v-show="visibility('add_custom_bills')"
           class="col-span-1 flex flex-col text-center cursor-pointer border-t-2 border-green-600 bg-white shadow rounded-md" tag="li" to="/custom-bill">
            <div class="flex-1 flex flex-col p-5">
              <div class="flex-shrink-0 mx-auto">
                <svg-vue class="block-link-icon" icon="font-awesome.plus-circle-solid"></svg-vue>
              </div>
              <h3 class="form-description-head">
                {{ $t('Custom bill') }}
              </h3>
              <p class="form-description-text">
                {{ $t('Create custom quick bill') }}
              </p>
            </div>
          </router-link>
          <router-link
            v-show="visibility('add_repairs')"
           class="col-span-1 flex flex-col text-center cursor-pointer border-t-2 border-green-600 bg-white shadow rounded-md" tag="li" to="/repair-booking">
            <div class="flex-1 flex flex-col p-5">
              <div class="flex-shrink-0 mx-auto">
                <svg-vue class="block-link-icon" icon="font-awesome.file-invoice-solid"></svg-vue>
              </div>
              <h3 class="form-description-head">
                {{ $t('Book repair order') }}
              </h3>
              <p class="form-description-text">
                {{ $t('Repair order booking for repairing') }}
              </p>
            </div>
          </router-link>
          <router-link
            v-show="visibility('add_custom_products')"
          class="col-span-1 flex flex-col text-center cursor-pointer border-t-2 border-green-600 bg-white shadow rounded-md" tag="li" to="/custom-product">
            <div class="flex-1 flex flex-col p-5">
              <div class="flex-shrink-0 mx-auto">
                <svg-vue class="block-link-icon" icon="font-awesome.file-invoice-dollar-solid"></svg-vue>
              </div>
              <h3 class="form-description-head">
                {{ $t('Buy from customer') }}
              </h3>
              <p class="form-description-text">
                {{ $t('Buy product form walk in customer for reselling') }}
              </p>
            </div>
          </router-link>
        </ul>
      </div>
    </div>
  </main>
</template>
<script>
import { includes, forEach } from 'lodash';
export default {
  name: 'home',
  metaInfo() {
    return {
      title: this.$i18n.t('Welcome'),
    };
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    permissions() {
      return this.$store.getters['app/getPermissions'];
    },
    user() {
      return this.$store.getters['app/getUser'];
    },
  },
  methods: {
    visibility(key) {
      if (this.user.role_id < 2) {
        return true;
      }
      return includes(this.permissions, key);
    },
  },
};
</script>
